<template>
  <nav-bar title="配置钢瓶组" />
  <content :bottom="76">
    <van-form ref="formRef" @submit="onSubmit">
      <field
        class="fileld"
        label="钢瓶组名称"
        :defaultValue="cgName"
        placeholder=""
        :disabled="true"
      />
      <field
        class="fileld"
        label="已分配销售组"
        :defaultValue="departName"
        placeholder=""
        :disabled="true"
      />
      <Picker
        label="分配销售组"
        :columns="groupList"
        :require="true"
        text="name"
        @confirm-values="(values) => (groupId = values.id)"
      />
    </van-form>
  </content>
  <div class="btns">
    <van-button type="primary" block @click="handleSubmitClick">
      保存
    </van-button>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { ref, computed } from 'vue'
import { groupListByCompanyId } from '@/api/cylinderManageUserHome'
import { getCyGroupInfo, updateCyGroupInfo } from '@/api/cylinderInfo'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
  name: 'ConfigureCylinderGroup', // 配置钢瓶组
  props: ['cgId'],
  setup(props) {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const cgName = ref('')
    // 获取销售组列表
    const groupList = ref([])
    const groupId = ref('')
    const groupName = ref('')
    const getGroupList = async () => {
      const { status, data } = await groupListByCompanyId({
        companyId: companyId.value
      })
      if (status === 200) {
        groupList.value = data
      }
    }
    getGroupList()
    // 初始化钢瓶组信息
    const cyGroupInfo = ref({})
    const initCyGroupInfo = async () => {
      const { status, data } = await getCyGroupInfo(props.cgId)
      if (status === 200) {
        cyGroupInfo.value = data
        cgName.value = data.cgName
      }
    }
    initCyGroupInfo()
    // 提交
    const router = useRouter()
    const formRef = ref(null)
    const handleSubmitClick = () => {
      formRef.value.submit()
    }
    const onSubmit = async () => {
      // loading
      Toast.loading({
        message: '请稍后...',
        forbidClick: true,
        duration: 0
      })
      const { status } = await updateCyGroupInfo({
        ...cyGroupInfo.value,
        cyList: cyGroupInfo.value.relaCylinderList.map((item) => ({
          gsId: item.gsId,
          gsCode: item.gsCode
        })),
        departId: groupId.value
      })
      Toast.clear()
      if (status === 200) {
        Toast.success('保存成功')
        setTimeout(() => {
          router.back()
        }, 1000)
      }
    }
    return {
      onSubmit,
      cgName,
      groupList,
      groupId,
      handleSubmitClick,
      formRef,
      groupName,
      departName: computed(() => cyGroupInfo.value.departName)
    }
  }
}
</script>

<style lang="scss" scoped>
.btns {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 16px;
  background: #fff;
}
</style>
